export default function ContentEight({ verticalTabsState }) {
  return (
    <div
      className={`content-8 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 8
          ? "max-h-[5000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px]">
        <strong>Manage</strong>
      </h2>

      <p className="text-[18px] mb-[25px] leading-[28px]">
        Manufacturing orders
      </p>

      <p className="mb-5 text-[16px]">
        Manage your products into assembly lines or manual assembly.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">Repair orders</p>

      <p className="mb-5 text-[16px]">
        Manage repairs of items under warranty or as a service.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">Work orders</p>

      <p className="mb-5 text-[16px]">
        Launch production of items needed in the final assembly of your
        products.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">Editable MOs</p>

      <p className="mb-5 text-[16px]">
        You are now able to consume other products despite what was initially
        planned and edit MOs once they are done.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">Unbilled orders</p>

      <p className="mb-5 text-[16px]">
        Disassemble a finished product and recuperate components.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px]">
        <strong>Flexible Master Data</strong>
      </h2>

      <p className="text-[18px] mb-[25px] leading-[28px]">
        Create multi-level Bills of Materials
      </p>

      <p className="mb-5 text-[16px]">
        Set a Bill of Materials within another in order to manufacture
        components of a product in another Bill of Materials.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">Version changes</p>

      <p className="mb-5 text-[16px]">
        Allow your products to evolve and add configurable options when creating
        orders.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">Quality Checks</p>

      <p className="mb-5 text-[16px]">
        Deploy your statistical process control easily with checks.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px]">
        <strong>Maintenance</strong>
      </h2>

      <p className="text-[18px] mb-[25px] leading-[28px]">
        Preventive Maintenance
      </p>

      <p className="mb-5 text-[16px]">
        Trigger maintenance requests automatically based on KPIs.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">Calendar</p>

      <p className="mb-5 text-[16px]">
        Schedule maintenance operations with a calendar.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">
        Corrective Maintenance
      </p>

      <p className="mb-5 text-[16px]">
        Trigger corrective maintenance directly from the control center panel.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px]">
        <strong>Workcenter Control Panel</strong>
      </h2>

      <p className="text-[18px] mb-[25px] leading-[28px]">Tablets</p>

      <p className="mb-5 text-[16px]">
        Set tablets on every work center to organize their work efficiently.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">isc Operations</p>

      <p className="mb-5 text-[16px]">
        Scrap products, create quality alerts, perform checks, right from the
        workcenter.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">Record production</p>

      <p className="mb-5 text-[16px]">
        Register productions, scan products, lots or serial numbers.
      </p>

      <p className="text-[18px] mb-[25px] leading-[28px]">work order steps</p>

      <p className="mb-5 text-[16px]">
        Define multiple steps in a workorder and link them to worksheet pages:
        scan a product, take a picture, quality control, etc.
      </p>
    </div>
  );
}
